import React from 'react';
import styled from 'styled-components';
import { asStyledComponent } from '@clds/component-enhancer';
import { globalTheme } from '@clds/component-theme';
import { CheckCircle, Error, Warning } from '@clds/icon';
import { typographyMixin } from '@clds/typography';
import { formTheme, validationVariant } from './theme';
const Root = styled.p `
  display: flex;
  align-items: flex-start;
  margin: ${formTheme.validation.margin.vertical} 0;
  ${validationVariant((branch) => typographyMixin(branch))};

  svg {
    margin-right: ${globalTheme.spacing.xxs};
    height: ${globalTheme.spacing.sm};
    width: ${globalTheme.spacing.sm};
    flex-shrink: 0;
  }
`;
const getIcon = (validationState) => ({
    none: null,
    success: React.createElement(CheckCircle, { size: "sm" }),
    warning: React.createElement(Error, { size: "sm" }),
    error: React.createElement(Warning, { size: "sm" }),
}[validationState]);
export const ValidationMessage = asStyledComponent(({ type = 'none', rootProps, children, className }) => (React.createElement(Root, Object.assign({ "data-test": "validation-info", type: type }, rootProps, { className: className }),
    getIcon(type),
    React.createElement("span", null, children))));
//# sourceMappingURL=ValidationMessage.js.map